import { render, staticRenderFns } from "./EnvironmentBanner.vue?vue&type=template&id=8a832f24&"
import script from "./EnvironmentBanner.vue?vue&type=script&lang=ts&"
export * from "./EnvironmentBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports